import { Flex, Spinner } from '@chakra-ui/react'

export default function PageLoader() {
    return (
        <Flex
            position="fixed"
            zIndex={100000}
            align="center"
            justify="center"
            w="100vw"
            minH="100vh"
            backgroundColor="#ffffff"
        >
            <Spinner />
        </Flex>
    )
}
